import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchSellersIfNeeded } from '@/redux/modules/seller';

export default async ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch } = store;
    const sellerId = Number(params.sellerId);

    if (!sellerId) {
        return Promise.resolve();
    }

    return dispatch(fetchSellersIfNeeded([sellerId]));
};
